module.exports = __webpack_public_path__ + "static/img/3.4b4b7ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/3.png
// module id = KM4K
// module chunks = 0